export const AgencySlice = (set, get) => ({
    AgencyInfo: {
        agency_id: '',
        primary_ea_id: ''
    },


    setAgencyInfo: (newInfo) =>
        set((state) => ({
            AgencyInfo: {
                ...state.AgencyInfo,
                ...newInfo
            },
        })),


    resetAgencyInfo: () =>
        set(() => ({
            AgencyInfo: {
                agency_id: '',
                primary_ea_id: ''
            }
        })),

})


// WEBPACK FOOTER //
// ./src/store/slices/AgencySlice/AgencySlice.js